import { IDSK } from "@examspark/types";

/** Returns [workspace/bank] formatted bankId string. */
export function getBankIdFromData(data: IDSK) {
  const reg = data.sk.match(/bank#(.*)/);
  const bankId = `${data.id}/${reg?.[1]}`;
  return bankId;
}

export function bankIdToIDSK(data: string): IDSK {
  const [workspaceId, bankKey] = data.split("/");
  if (!workspaceId || !bankKey) {
    throw new Error(`Invalid bank ID: ${data}`);
  }
  return { id: workspaceId, sk: `bank#${bankKey}` };
}
